import { Component, EventEmitter, OnInit, Input, Output, ViewChild, forwardRef } from '@angular/core';
import { EmailValidator, FormBuilder, FormGroup, Validators, FormArray } from '@angular/forms';
import {Message, OverlayPanel, SelectItem} from 'primeng/primeng';
import * as _ from "lodash";

//validators
import { dropDownValidator }                from '../../validators/CustomValidators';
import { hiddenDropDownValueValidator }                from '../../validators/CustomValidators';

import * as ent from '../../entities/index'
import * as enums from '../../enums/index'
import * as filters from '../../filters/index'
import * as util from '../../util/index'

//components


//constants
import { Constants }         from '../../constants/Constants';

//base
import { BaseControlGroupComponent }         from '../../baseclasses/BaseControlGroup.component';
import { CompletionNumberType, RequestTotalsByTypeAndStatus } from '../../entities/index';

@Component({
  selector: 'my-completiondetails',
  templateUrl: './CompletionDetails.component.html',
  providers: [{provide: BaseControlGroupComponent, useExisting: forwardRef(() => CompletionDetailsComponent)}]
})
export class CompletionDetailsComponent extends BaseControlGroupComponent {

    completionDetailsForm: FormGroup;
    completionNumber: string;
    showControl: boolean = false;
    showSingle: boolean = false;
    showMultiple: boolean = false;
    @Input() showEquipmentLineItemIdentifierColumn: boolean = false;
    @Input() showPartnerTypeColumn: boolean = false;
    @Input() showMoreInfoColumn: boolean = false;
    @Input() showAddButton: boolean = true;
    @Input() showDeleteButtons: boolean = true;
    request: ent.Request;
    lineItems: ent.RequestCompletionNumber[] = [];
    completionNumberLabelLineItems: SelectItem[] = [];
    completionNumberLabels: ent.CompletionNumberLabel[] = [];

    setDates(){}

    setRequestInfo(request: ent.Request){
        this.request = request;
        this.showSingle = false;
        this.showMultiple = false;
        
        
        if (util.SecurityUtil.SubmitUsingAPI(request.RequestType)) {
            if (request.RequestCompletionNumbers.length > 0){
                this.showControl = true;
                if (!util.SecurityUtil.CanAccessFeature(this.userInfo, enums.Feature.PerformRequestWorkflow)){
                    this.showAddButton = false;
                    this.showDeleteButtons = false;
                }
            }
        }
        else{
            this.showControl = util.SecurityUtil.ShowCompletionDetails(this.request, this.userInfo);
        }
        
        if (this.showControl){
            this.lineItems = [];
            if (this.request.RequestType.CompletionNumberTypeID == enums.CompletionNumberTypeEnum.Single){
                this.showSingle = true;
                this.completionDetailsForm.controls.completionNumber.setValidators(Validators.required);
                if (request.RequestCompletionNumbers != undefined && request.RequestCompletionNumbers.length > 0){
                    this.completionNumber = request.RequestCompletionNumbers[0].Number;
                }
            }
            else if (this.request.RequestType.CompletionNumberTypeID == enums.CompletionNumberTypeEnum.Multiple){
                this.showMultiple = true;
                if (request.RequestCompletionNumbers != undefined && request.RequestCompletionNumbers.length > 0){
                    this.lineItems = request.RequestCompletionNumbers;    
                }
            }
        }
    }


    constructor(fb: FormBuilder) 
    { 
        super();
        
        let group = {
          'completionNumber' : ''
        };
        
        this.completionDetailsForm = fb.group(group);

    }

    ngOnInit(): void {
        var filter: filters.CompletionNumberLabelFilter = {IncludeInactive: false};
        this.domainDataService.getCompletionNumberLabels(filter).subscribe(items=> 
            {
                items.forEach(y=> this.completionNumberLabels.push(y));

                this.completionNumberLabelLineItems.push({label:"", value:Constants._NONE});
                items.forEach(y=> this.completionNumberLabelLineItems.push({label:y.Name, value:y.ID}));
            }
            
        );
    }

    completionNumberLabelChange(event: any, lineItem: ent.RequestCompletionNumber){
        var completionNumberLabel = this.completionNumberLabels.filter(x=>x.ID == event)[0];
        if (!lineItem.CompletionNumberLabel || lineItem.CompletionNumberLabel.ID != completionNumberLabel.ID){
            lineItem.CompletionNumberLabel = completionNumberLabel;
            lineItem.CompletionNumberLabelID = completionNumberLabel.ID;

        }
        
    }

    onAddLineItemClick(event: any){
        if (!this.lineItems){this.lineItems = []}
        var newLineItem: ent.RequestCompletionNumber = {RequestID: this.request.ID, Number: ""};

        this.lineItems = [...this.lineItems, newLineItem];
    }

    onDeleteClick(event: any, lineItem: ent.RequestCompletionNumber){
        this.lineItems = _.remove(this.lineItems, x=>x.ID !== lineItem.ID);
    }


}